import type { ILog } from "@/data/model/Log";
import type { ITablesQry } from "@/data/queries/table/TablesQry";
import { DateTime } from "@/data/util/DateTime";

import { BaseServiceDao, type IDataSource, type IPaginatedResult, parsePaginatedResult } from "./BaseServiceDao";

export class LogDao extends BaseServiceDao implements IDataSource<ILog> {
    public static className = "LogDao";

    constructor() {
        super("log");
    }

    public async getData(qry: ITablesQry): Promise<IPaginatedResult<ILog>> {
        return this.get("", qry, (f) => parsePaginatedResult(f, LogDao.parseLog));
    }

    public async clearLogs(): Promise<void> {
        return this.delete("");
    }

    public static parseLog(literal: any): ILog {
        return {
            id: literal.id,
            title: literal.title,
            message: literal.message == null ? undefined : literal.message,
            level: parseInt(literal.level),
            created: DateTime.parseIsoDate(literal.created),
        };
    }
}
